"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourtSystemResourceEventTypes = exports.CourtSystemEventTypes = void 0;
var CourtSystemEventTypes;
(function (CourtSystemEventTypes) {
    CourtSystemEventTypes["CONFIGURED_RESTRICTED_PERMISSIONS"] = "COURT_SYSTEM/CONFIGURED_RESTRICTED_PERMISSIONS";
    CourtSystemEventTypes["CONFIGURED_RECORDING_LICENSE"] = "COURT_SYSTEM/CONFIGURED_RECORDING_LICENSE";
})(CourtSystemEventTypes || (exports.CourtSystemEventTypes = CourtSystemEventTypes = {}));
var CourtSystemResourceEventTypes;
(function (CourtSystemResourceEventTypes) {
    CourtSystemResourceEventTypes["RESOURCE_CREATED"] = "RESOURCE_CREATED";
    CourtSystemResourceEventTypes["RESOURCE_UPDATED"] = "RESOURCE_UPDATED";
    CourtSystemResourceEventTypes["RESOURCE_DELETED"] = "RESOURCE_DELETED";
})(CourtSystemResourceEventTypes || (exports.CourtSystemResourceEventTypes = CourtSystemResourceEventTypes = {}));
